import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/switch-vertical-01.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M6.00005 20V6.41406L3.70708 8.70703C3.31655 9.09756 2.68354 9.09756 2.29302 8.70703C1.90249 8.31651 1.90249 7.68349 2.29302 7.29297L6.29302 3.29297L6.36919 3.22461C6.76196 2.90426 7.34096 2.92685 7.70708 3.29297L11.7071 7.29297L11.7754 7.36914C12.0958 7.76191 12.0732 8.34092 11.7071 8.70703C11.341 9.07315 10.762 9.09574 10.3692 8.77539L10.293 8.70703L8.00005 6.41406V20C8.00005 20.5523 7.55233 21 7.00005 21C6.44776 21 6.00005 20.5523 6.00005 20ZM16 4C16 3.44772 16.4478 3 17 3C17.5523 3 18 3.44772 18 4V17.5859L20.293 15.293C20.6835 14.9024 21.3166 14.9024 21.7071 15.293C22.0976 15.6835 22.0976 16.3165 21.7071 16.707L17.7071 20.707C17.3166 21.0976 16.6835 21.0976 16.293 20.707L12.293 16.707L12.2247 16.6309C11.9043 16.2381 11.9269 15.6591 12.293 15.293C12.6591 14.9269 13.2381 14.9043 13.6309 15.2246L13.7071 15.293L16 17.5859V4Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as SwitchVertical01Icon };
